import type { AppTheme } from '../types/schema'

type Listener = (override: AppTheme | null) => void

let currentOverride: AppTheme | null = null
const listeners = new Set<Listener>()

export const getSurfaceThemeOverride = (): AppTheme | null => currentOverride

export const setSurfaceThemeOverride = (next: AppTheme | null): void => {
  if (currentOverride === next) return
  currentOverride = next
  for (const listener of listeners) listener(currentOverride)
}

export const subscribeSurfaceThemeOverride = (listener: Listener): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
